
import React, { useState } from "react";
import "./UOD.css";

const CustomModal = ({
  students,
  handleSkip,
  handleSkipAll,
  handleOverride,
  closeModal,
}) => {
  const [studentStates, setStudentStates] = useState({});

  const handleSkipChange = (rollNo) => {
    setStudentStates((prevStates) => ({
      ...prevStates,
      [rollNo]: { skip: true, override: false },
    }));
    handleSkip(rollNo);
  };

  const handleOverrideChange = (rollNo) => {
    setStudentStates((prevStates) => ({
      ...prevStates,
      [rollNo]: { skip: false, override: true },
    }));
    handleOverride(rollNo);
    
  };
  return (
    <div className="student-modal">
      <div
        className="student-modal-content"
        style={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <span
          className="student-close"
          onClick={closeModal}
          style={{ position: "absolute", right: "10px", top: "10px" }}
        >
          ×
        </span>

        <div className="Btn-students-UOD" style={{ marginBottom: "20px" }}>
          <button
            style={{ margin: "1px" }}
            className="skip-btn-UOD"
            onClick={handleSkipAll}
          >
            Skip All
          </button>
          <button style={{ margin: "1px" }} className="override-btn-UOD"  onClick={closeModal}>
            Overwrite All
          </button>
          <button
            style={{ margin: "1px" }}
            className="next-btn-UOD"
            onClick={closeModal}
          >
            Next
          </button>
        </div>

        <div style={{ maxHeight: "500px", overflowY: "auto" }}>
          <table className="Student-table-UOD">
            <thead>
              <tr className="headers-UOD">
                <th>Roll Number</th>
                <th>Skip</th>
                <th>Overwrite</th>
              </tr>
            </thead>
            <tbody>
              {students.map((student) => (
                <tr key={student.student_id}>
                  <td>{student.roll_no}</td>
                  <td>
                    <input
                      type="checkbox"
                      className="skip-checkbox-UOD"
                      checked={studentStates[student.roll_no]?.skip}
                      onChange={() => handleSkipChange(student.roll_no)}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      className="override-checkbox-UOD"
                      checked={studentStates[student.roll_no]?.override}
                      onChange={() => handleOverrideChange(student.roll_no)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
